export default {
	lang: 'de',
	settings: {
		opener: {
			tooltip: 'Sichtbare Elemente',
		},
		sidebar: {
			title: 'Sichtbare Elemente',
			toggleAll: 'Alle ein/ausblenden',
		},
		mapType: {
			title: 'Kartentyp',
		},
		publicTransport: {
			title: 'Öffentlicher Nahverkehr',
			stops: 'Haltestellen',
			regionalTrain: 'R-Bahn',
			cityTrain: 'S-Bahn',
			cityRailway: 'Stadtbahn',
			bus: 'Bus',
		},
		sharing: {
			title: 'Sharing-Angebote',
			car2go: 'ShareNow',
			shareNow: 'ShareNow',
			flinkster: 'Flinkster',
			regioRad: 'RegioRad',
			stella: 'Stella',
			stadtMobil: 'Stadtmobil',
		},
		poi: {
			title: 'Interessante Orte',
			recreation: 'Freizeit',
			foodAndDrink: 'Essen & Trinken',
			culture: 'Kultur',
			landmarks: 'Sehenswürdigkeiten',
			aroundBike: 'Rund ums Rad',
			educationalInstitutions: 'Bildungseinrichtungen',
			hospitals: 'Krankenhäuser & Kliniken',
			clubs: 'Verbände & Vereine',
		},
	},
	myRoutes: {
		headline: 'Meine Routen',
		switch: {
			all: 'Alle',
			routes: 'Routen',
			bikeRoutes: 'Radtouren',
		},
		errors: {
			loading: 'Beim Laden der Route ist ein Fehler aufgetreten.',
			notFound: 'Die gespeicherte Route wurde nicht gefunden.',
		},
	},
	bikeRoutes: {
		headline: 'Radtouren',
		searchPlaceholder: 'Radtour suchen',
		switch: {
			az: 'A-Z',
			surrounding: 'Umgebung',
			distance: 'Länge',
			height: 'Höhe',
		},
		downloadPdf: 'PDF herunterladen',
	},
	bikeSettings: {
		title: 'Rad Einstellungen',
		route: {
			title: 'Art der Route',
			commuter: 'Pendlerroute',
			leisure: 'Freizeitroute',
			individual: {
				title: 'Individuell',
				preferThemeRoute: 'Radrouten bevorzugen',
				mainTracks: 'Hauptradwege bevorzugen',
				asphaltTracks: 'Asphaltwege bevorzugen',
				greenTracks: 'Wege im Grünen bevorzugen',
			},
		},
		fitness: {
			title: 'Fitness',
			untrained: 'Untrainiert',
			average: 'Durchschnittlich',
			sporty: 'Sportlich',
			electric: 'Elektrounterstützt',
			individual: 'Individuell',

			speed: {
				title: 'Geschwindigkeit',
				slow: 'Langsam ({{speed}} km/h)',
				normal: 'Normal ({{speed}} km/h)',
				fast: 'Schnell ({{speed}} km/h)',
				superfast: 'Sehr schnell ({{speed}} km/h)',
			},

			pitch: {
				title: 'Steigung',
				low: 'Möglichst vermeiden ({{pitch}} %)',
				medium: 'Geringe Steigung zulassen ({{pitch}} %)',
				high: 'Mittlere Steigung zulassen ({{pitch}} %)',
				full: 'Alle Steigungen zulassen ({{pitch}} %)',
			},
		},
		pavedPaths: {
			title: 'Befestigte Wege',
			only: 'Nur befestigte Wege',
			prefer: 'Befestigte Wege bevorzugen',
			avoid: 'Befestigte Wege vermeiden',
		},
	},
	publicTransportSettings: {
		title: 'ÖPNV Einstellungen',
		transport: 'Verkehrsmittel',
		bus: 'Bus',
		regionalTrain: 'R-Bahn',
		cityTrain: 'S-Bahn',
		cityRailway: 'Stadtbahn',
		cogRailway: 'Zahnradbahn',
		options: 'Optionen',
		shortedPossible: 'Möglichst kurze Radstrecke',
		maxTimeAccess: 'Maximale Fahrtdauer zum Einstieg',
		maxTimeExit: 'Maximale Fahrtdauer ab Ausstieg',
	},
	routePlanning: {
		previewText:
			'Geben Sie oben Ihre gewünschten (Zwischen-)Ziele ein und berechnen Sie Ihre Routenoptionen.',
		calculateRoute: 'Route berechnen',
		invalidPoints: 'Ungültige Routenpunkte',
		twoSamePointsNotAllowed:
			'Es darf nicht zweimal hintereinander der selbe Punkt ausgewählt werden.',
		bikeOnly: 'Mit dem Rad',
		bikeTransport: 'Fahrradmitnahme',
		bikeAndRide: 'Bike + Ride',
		bikeSharing: 'RegioRad ausleihen',
		hash: 'Geteilte Strecke',
		save: 'Route speichern',
		saved: 'Route gespeichert',
		downloadGpx: 'GPX Track herunterladen',
		copyLink: 'Link kopieren',
		footpath: '{{distance}} zu Fuß',
		bike: '{{distance}} mit dem Rad',
		departurePreposition: 'ab {{time}}',
		arrivalPreposition: 'an {{time}}',
		duration: '{{duration}} min',
		arrivalDestination: 'Am Ziel um {{time}}',
		info: '{{content}} [...] mehr',
		bikeStart: 'Starte um {{time}}',
		bikeEnd: 'Fahrad abstellen',
		savedModal: {
			headline: 'Die Route wurde gespeichert',
			text:
				'Die gespeicherte Route ist auf der Einstiegsseite unter „Meine Routen“ zu finden',
			button: 'Okay',
		},
	},
	routeDetails: {
		parkBike: 'Fahrrad abstellen',
		rentBike: 'Fahrrad mieten',
		byBike: 'Mit dem Rad',
		byFoot: 'Zu Fuß',
		details: 'Details',
	},
	common: {
		time: 'Zeit',
		sorting: 'Sortierung',
		fetching: 'Lade Daten',
		searchPlaceholder: 'Wohin soll es gehen?',
		searchPlaceholderStart: 'Startpunkt eingeben',
		searchPlaceholderEnd: 'Ziel eingeben',
		searchPlaceholderBetween: 'Zwischenziel eingeben',
	},
	mail: {
		address: 'beispiel@mail.de',
		subject: 'VVS-Radroutenplaner',
		share: 'E-Mail',
	},
	error: {
		headline: 'Es ist ein Problem aufgetreten.',
		fetching: 'Beim laden der Route ist ein Problem aufgetreten. Versuchen Sie es erneut.',
		routeNotFound: 'Die gesuchte Radroute wurde nicht gefunden.',
	},
	page: {
		navigation: {
			toVVS: 'Zur VVS Hauptseite',
			imprint: 'Impressum',
			privacy: 'Datenschutz',
			toPage: 'Radfahren im Verbundgebiet',
		},
		banner1: 'Radfahren im Verbundgebiet',
		banner2: 'mit dem VVS Radroutenplaner',
		bannerLabel: 'Radfahren im Verbundgebiet: Die besten Routen und Radtouren',
		centerSection: {
			headline:
				'Mit dem VVS-Radroutenplaner die schönsten Touren in der Region Stuttgart finden.',
			text:
				'Ob für Pendler- oder Freizeitradfahrer: Mit dem runderneuerten Radroutenplaner lassen sich geeignete Routen mit dem eigenen Rad, dem RegioRad oder in Kombination mit Bussen und Bahnen finden. Natürlich unter Berücksichtigung der Regeln bezüglich Fahrradmitnahme in den öffentlichen Verkehrsmitteln. Außerdem steht ein großes Angebot an fertigen Touren zur Verfügung. Alle Routen lassen sich teilen oder im gpx-Format exportieren.',
			button: 'Radroutenplaner',
			more: 'Mehr Infos zum Radroutenplaner',
		},
		moreSection: {
			headline: 'Der VVS-Radroutenplaner kann jetzt noch mehr',
			text:
				'Das Coronavirus hat das gesamte öffentliche Leben in den vergangenen Monaten in einen Ausnahmezustand versetzt. Kulturelle Veranstaltungen wurden abgesagt, Geschäf- te, Restaurants und Bars mussten schließen. Viele Menschen haben die Zeit genutzt, um die Region auf eigene Faust zu erkunden – abseits von Menschenmassen zum Beispiel auf dem Fahrrad.\n\nDass der Radsport boomt, haben in der Pan- demie nicht nur Fachgeschäfte gemerkt, sondern auch der VVS mit seinem Radroutenplaner.\n\nRechtzeitig zum Start in die schönen Jahreszeiten bekommt das praktische Tool ein komplett neues Aussehen und neue Funktionen. Die komplette Auskunft basiert nun auf einer modernen und schnellen Kartentechnik – das heißt Abruf und Planung von Routen funktioniert deutlich schneller. Außerdem sind in der neuen Version auch die Mieträder von Re- gioRad integriert, sodass man genaue Infos bekommt, wo ein Rad verfügbar ist und ob es sich um ein normales oder eine E-Bike handelt.\n\nDer Radroutenplaner ist ein toller Begleiter, den es im Web seit 2007 gibt. Als App ist er seit 2013 verfügbar. Mit ihm lassen sich nicht nur individuelle Routen im gesamten VVS-Gebiet inklusive des neuen Verbund- landkreises Göppingen zusammenstellen. Radfahrer können auch aus zahlreichen vorgegebenen Radrouten die Tour auswäh- len, die sie am besten passt – inklusive auto- matischer Navigation. Der Radroutenplaner zeigt wahlweise verschiedene Streckenalter- nativen an. Eine seiner Stärken ist nicht nur die reine Radroute, sondern auch die multi- modale Auskunft. Zum Beispiel mit dem Rad zur Haltestelle, Fahrrad dort abstellen oder an der Mietstation zurück geben zurückge- ben und dann weiter mit Bus und Bahn oder umgekehrt.\n\nFür alle, die Ihr Fahrrad in Bus oder Bahn mitnehmen möchten, hat der Radroutenplaner ebenfalls eine spezielle Auswahlmöglichkeit parat. Natürlich werden dabei auch die Fahrradmitnahmeregeln und Sperrzeiten, in denen man kein Fahrrad oder nur mit zusätzlichem Ticket, mitnehmen darf im VVS berücksichtigt.\n\nDer VVS Readroutenplaner wird vom Bundesverkehrsministerium das "Programm saubere Luft" im Rahmen der Digitalisierung kommunaler Verkehrssysteme gefördert.',
			infoBoxHeadline: 'Die wichtigsten Merkmale des Radroutenplaners im Überblick',
			infoBoxList: [
				'→ Routenplanung in der Region Stuttgart (VVS-Gebiet inklusive des neuen Verbundlandkreises Göppingen)',
				'→ Start- und Zieleingabe per Ortung, Adresse, Point of Interest (POI), Haltestelle sowie über Auswahl eines beliebigen Kartenpunktes',
				'→ Verwendung von beliebigen Zwischenpunkten – auch über die Karte',
				'→ Wahl zwischen Pendler- und Freizeitroute',
				'→ Alternativrouten mit und ohne Fahrradmitnahme in Bussen und Bahnen',
				'→ Route mit RegioRad-Ausleihe und Link zur Buchung',
				'→ Verschiedene Fitness-Level einstellbar',
				'→ Abspeichern von Routen',
				'→ Teilen von abgespeicherten Routen',
				'→ Auswahl zwischen verschiedenen Karten und Luftbildern',
				'→ RegioRad-Standorte mit aktueller Verfügbarkeit von Rädern',
				'→ außerdem Sharing-Standorte von Stadtmobil, Stella, ShareNow und Flinkster mit aktueller Verfügbarkeit bzw. Ladezustand',
				'→ Zuschalten von POIs in der Karte',
				'→ Über 130 Themenrouten',
			],
		},
		bikeSection: {
			headline: 'Fahrradmitnahme in Bussen und Bahnen',
			text:
				'Ganz einfach das Fahrrad im Vorstellwagen der Zahnradbahn oder im Fahrradanhänger von Freizeitbussen mitnehmen. Wir erklären Regelungen zur Mitnahme von Fahrrädern in Bussen und Bahnen.',
			button: 'Mehr Infos',
		},
		regioRadPolygoSection: {
			headline: 'RegioRadStuttgart und polygo',
			text:
				'Mit der polygocard an über 200 Stationen im VVS RegioRäder ausleihen. Das Angebot umfasst 1.500 Fahrräder, davon knapp 600 Pedelecs.',
			button: 'Mehr Infos',
		},
		bikeHikeBusSection: {
			headline: 'Radfahren und Wandern mit den Freizeitbussen im VVS',
			text:
				'Mit den Rad- und Wanderbussen können Ausflügler bequem zu den Startpunkten für ihre Touren kommen. Sie sind zum VVS-Tarif unterwegs und das Fahrrad kommt sogar umsonst mit.',
			button: 'Mehr Infos',
		},
		roundlyMobileSection: {
			headline: 'RundUm Mobil alle Mobilitätsangebote auf einen Blick',
			text:
				'Auf dieser Seite bündelt der VVS sämtliche Serviceleistungen rund um die Mobilität, wie z.B. Fahrrad-Service-Stastionen, Bürger- und Ortsbusse,  Rikscha-Fahrdienste, SSB Flex, E-Scooter uvm.',
			button: 'Mehr Infos',
		},
	},
};
